import { Link } from 'react-router-dom';
import { getHotComics } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

export default function HotComics() {
  const hotComics = getHotComics(8);

  return (
    <section className="py-10 md:py-14 bg-background-100" aria-label="热门推荐">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最受读者欢迎的韩漫作品，不容错过</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}